export const formatMonthlyPrice = (
  cents: number | null | undefined,
  currency: string | null | undefined
) => {
  if (!cents) return null
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency?.toUpperCase() || "USD",
  }).format(cents / 100)
}
